import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { PartnerStore } from '@app/partners/model/partner.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-partner-store',
    templateUrl: './partner-store.component.html',
    styleUrls: ['./partner-store.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class PartnerStoreComponent {
    @Input({ required: true }) store!: PartnerStore;
}
